import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { handleActions } from 'redux-actions';
import { fetchPrivilegesSuccess } from '../actions/privileges';
const defaultState = {};
export default handleActions({
    [fetchPrivilegesSuccess.toString()]: (state, action)=>_object_spread({}, state, action.payload)
}, defaultState);
